import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import CommonUtil from '../util/CommonUtils';

function CustomCarousel({ punchMenus, screenSize, setPunchMenusDisplay }) {
    const { isMobile, isTablet, isLaptop, isDesktop } = screenSize;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerSlide, setItemsPerSlide] = useState(8);

    // Update itemsPerSlide based on screen size
    useEffect(() => {
        const determineItemsPerSlide = () => {
            if (isMobile) return 4;
            if (isTablet) return 8;
            // if (isLaptop && !CommonUtil.isEmpty(punchMenus) && punchMenus?.length <= 8) return 8
            if(isLaptop) return 8
            // if (isDesktop) return 16
            return 8;
        };
        setItemsPerSlide(determineItemsPerSlide());
        setCurrentIndex(0);
    }, [isMobile, isTablet, isLaptop]);

    // Update displayed items
    useEffect(() => {
        const updatedItems = punchMenus.slice(currentIndex, currentIndex + itemsPerSlide);
        setPunchMenusDisplay?.(updatedItems);
    }, [currentIndex, itemsPerSlide, punchMenus]);

    // Navigation handlers
    const canSlidePrev = currentIndex > 0;
    const canSlideNext = currentIndex + itemsPerSlide < punchMenus.length;

    const handlePrev = () => canSlidePrev && setCurrentIndex((prev) => prev - itemsPerSlide);
    const handleNext = () => canSlideNext && setCurrentIndex((prev) => prev + itemsPerSlide);

    // Button styles
    const buttonStyle = {
        top:isMobile?'63%':isTablet?'55%':isLaptop?'55%':'58%',
        transform: 'translateY(-50%)',
        position: 'fixed',
        height:'50px'
    };

    return (
        <>
            {canSlidePrev && (
                <Button
                    onClick={handlePrev}
                    icon={<LeftOutlined />}
                    style={{ ...buttonStyle, left: 0 }}
                />
            )}
            {canSlideNext && (
                <Button
                    onClick={handleNext}
                    icon={<RightOutlined />}
                    style={{ ...buttonStyle, right: 0 }}
                />
            )}
        </>
    );
}

export default CustomCarousel;
